import React from 'react';
import styles from './ContactorTypeSelect.module.scss';
import cn from 'classnames';
import { ReactComponent as OrganizationIcon } from '../../../../resource/OrganizationIcon.svg';
import { ReactComponent as PeopleorOwnerIcon } from '../../../../resource/PeopleorOwnerIcon.svg';

const ContactorTypeSelect = ({ value, onChange, disabled }) => {
  return (
    <div className={styles.root}>
      <div
        className={cn(styles.content, {
          [styles.active]: value === 'fio_data',
          [styles.disabledBtn]: disabled,
        })}
        onClick={() => (!disabled ? onChange('fio_data') : null)}
      >
        <PeopleorOwnerIcon />
        Собственник
      </div>

      <div
        className={cn(styles.content, {
          [styles.active]: value === 'org_data',
          [styles.disabledBtn]: disabled,
        })}
        onClick={() => (!disabled ? onChange('org_data') : null)}
      >
        <OrganizationIcon />
        Организация
      </div>
    </div>
  );
};
export default ContactorTypeSelect;
